import React, { useState } from "react";
import { TfiClose } from "react-icons/tfi";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

const Card = ({ assets }) => {
  const firstFilter = assets.filter(
    (asset) => asset.id !== "cli526igxj15s0bw2839ciz6i"
  );
  const tattoos = firstFilter.filter(
    (asset) => asset.id !== "cli526ihjj21x0bw6pn3d6c71"
  );
  const [current, setCurrent] = useState(null);
  const handleClose = (event) => {
    event.stopPropagation();
    setCurrent(null);
  };
  return (
    <CardsWrapper>
      {tattoos.map((tattoo) => (
        <CardStyled
          key={tattoo.id}
          onClick={() => setCurrent(tattoo.id)}
        >
          {tattoo.id !== current && (
            <div
              className={current === tattoo.id ? "absolute" : "static"}
              style={{
                rotate: `${Math.random() * 15 - 7.5}deg`,
              }}
            >
              <img
                src={tattoo.url}
                alt={tattoo.id}
                loading="lazy"
              />
            </div>
          )}
          <AnimatePresence>
            {tattoo.id === current && (
              <motion.div
                className="openWrapper"
                onClick={handleClose}
                initial={{ opacity: 0.5 }}
                animate={{
                  opacity: 1,
                  transition: { duration: 0.3 },
                }}
                exit={{ opacity: 0 }}
              >
                <EnlargedImage>
                  <img
                    src={tattoo.url}
                    alt={tattoo.id}
                    loading="lazy"
                  />
                  <TfiClose
                    size={30}
                    className="close"
                    onClick={handleClose}
                  />
                </EnlargedImage>
              </motion.div>
            )}
          </AnimatePresence>
        </CardStyled>
      ))}
    </CardsWrapper>
  );
};

export default Card;

const CardsWrapper = styled.div`
  width: 70%;
  margin: 20vh auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 5vw;
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const CardStyled = styled.div`
  .static {
    transform-origin: top;
    box-shadow: 10px 10px 100px rgba(0, 0, 0, 1);
    box-shadow: 15px 15px 100px rgba(0, 0, 0, 1);
    position: static;
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    padding-top: 5%;
    cursor: pointer;
    transition: all 0.1s ease-in;
    .close {
      display: none;
    }
    img {
      width: 90%;
      height: 70%;
      object-fit: cover;
      transition: filter 0.3s ease-in-out;
      filter: grayscale(1);
    }
  }
  :hover img {
    filter: grayscale(0);
    -webkit-filter: grayscale(0);
  }
  @media (min-width: 992px) {
    .static:hover {
      transform: perspective(800px) rotateX(5deg);
      -webkit-transform: none;
    }
  }

  .absolute {
    display: none;
  }
  .openWrapper {
    position: fixed;
    inset: 0;
    display: grid;
    place-items: center;
    background: rgba(0, 0, 0, 0.6);
    z-index: 5;
    overflow: hidden;
  }
`;

const EnlargedImage = styled.div`
  background: #fff;
  rotate: 0deg;
  width: min(90vw, 64vh);
  height: min(112.5vw, 80vh);
  display: flex;
  justify-content: center;
  padding-top: min(5vw, 28px);
  z-index: 10;
  box-shadow: 10px 10px 100px rgba(0, 0, 0, 1);
  box-shadow: 15px 15px 100px rgba(0, 0, 0, 1);
  .close {
    position: absolute;
    bottom: 5vh;
    cursor: pointer;
    z-index: 20;
    color: black;
  }
  img {
    width: 90%;
    height: 70%;
    object-fit: cover;
  }
`;
